export const makeCallAll =
  <P extends any[]>(...fns: Array<(...a: P) => void>) =>
  (...args: P) =>
    fns.forEach(fn => fn?.(...args));
